import React from "react";

const ProfileContent = () => {
    return (
        <div>
            <h2 className="text-2xl font-bold mb-4">Profile</h2>
            <p>View detailed information for your profile.</p>
        </div>
    );
};

export default ProfileContent;
